import React from 'react';
import { Link } from 'react-router-dom';
import CookieBanner from '../components/CookieBanner';
import logo from '../assets/zwyk-logo-dark2.svg';
import '../styles/EuFunding.css';

const EuFunding: React.FC = () => (
  <div className="eu-funding">
    <header className="eu-funding-header">
      <Link to="/">
        <img src={logo} alt="Zwyk Logo" height={40} width={40} />
      </Link>
    </header>

    <main className="eu-funding-main">
      <Link to="/" className="eu-funding-back">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        Wróć na stronę główną
      </Link>

      <img
        src={require('../assets/eu-template.jpg')}
        alt="Fundusze Europejskie dla Polski Wschodniej, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską"
        className="eu-funding-logos"
      />

      <p className="eu-funding-eyebrow">Dofinansowanie z Unii Europejskiej</p>
      <h1>ZWYK – innowacyjna platforma turystyki górskiej z integracją społeczności i systemem nagród</h1>
      <p>
        ZWYK sp. z o.o. realizuje projekt dofinansowany przez Unię Europejską w ramach programu Fundusze Europejskie
        dla Polski Wschodniej 2021–2027, działanie 1.1 „Platformy startowe dla nowych pomysłów”, komponent IIa —
        wsparcie rozwoju działalności gospodarczej startupu.
      </p>

      <h2>O projekcie</h2>
      <p>
        Celem projektu jest rozwój i wprowadzenie na rynek platformy ZWYK, która łączy planowanie wypraw górskich,
        budowanie społeczności oraz system cyfrowych nagród. Dzięki realizacji projektu użytkownicy otrzymają rozwinięte
        narzędzie do organizowania wspólnych aktywności, a partnerzy turystyczni — nowe możliwości prezentowania swojej
        oferty i współpracy z turystami.
      </p>
      <p>
        W ramach projektu rozwijamy funkcjonalności aplikacji, prowadzimy testy i pilotaże z użytkownikami oraz
        partnerami, wdrażamy system profili miejsc, kodów QR i cyfrowych odznak. Przygotowujemy także płatne usługi dla
        użytkowników i partnerów biznesowych oraz platformę do komercjalizacji.
      </p>
      <p>
        Projekt jest skierowany do turystów indywidualnych, rodzin, grup i organizatorów wypraw, a także schronisk,
        obiektów noclegowych, organizacji turystycznych oraz innych podmiotów związanych z turystyką górską
        i outdoorową.
      </p>

      <h2>Informacje o projekcie</h2>
      <dl className="eu-funding-details">
        <dt>Beneficjent</dt>
        <dd>ZWYK sp. z o.o.</dd>
        <dt>Numer projektu</dt>
        <dd>FEPW.01.01-IP.01-0907/26</dd>
        <dt>Okres realizacji</dt>
        <dd>1 października 2026 r. – 30 września 2027 r.</dd>
        <dt>Całkowita wartość projektu</dt>
        <dd>735 337,98 zł</dd>
        <dt>Wysokość wkładu Funduszy Europejskich</dt>
        <dd>599 731,73 zł</dd>
      </dl>

      <p className="eu-funding-tags">#FunduszeUE #FunduszeEuropejskie</p>
    </main>

    <CookieBanner />
  </div>
);

export default EuFunding;
